const apiMethods = {
    TOKEN_REFRESH: '/oauth/token',
    USER_DATA: '/user',
    PAYMENTS: '/payments',
    PAYMENT_DELETE: paymentId => (
        `/payments/${paymentId}`
    ),
    JURISDICTIONS: '/jurisdictions',
    PAYMENT_STATES: '/payment-states',
    PAYMENT_TYPES: '/payment-types?parent=0',
    PROCEEDINGS: '/proceedings',
    CHECKOUT: '/payments/checkout',
    CHECKOUT_BRANCH: lotId => (
        `/payments/checkout/${lotId}/branch`
    ),
    CHECKOUT_ONLINE: lotId => (
        `/payments/checkout/${lotId}/online`
    ),
    CHECKOUT_ONLINE_SUCCESS: paymentId => (
        `/payments/checkout/${paymentId}/online/success`
    ),
    CHECKOUT_CANCEL: '/payments/checkout/cancel'
};

export default apiMethods;